import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 32,
    maxWidth: '100%',
  },
  copyright: {
    alignItems: 'center',
    color: theme.palette.text.subtitle,
    display: 'flex',
    fontSize: theme.typography.pxToRem(11),
    fontWeight: 300,
    height: '100%',
    justifyContent: 'flex-end',
    width: '100%',
  },
}));

export default useStyles;
